<template>
  <el-table :data="tableData" style="color:black;font-size: large;">
    <el-table-column prop="column1" label="Species"></el-table-column>
    <el-table-column prop="column2" label="Tissue"></el-table-column>
  </el-table>
</template>
  
<script>
export default {
    data() {
        return {
        tableData: [
            { 
              column1: this.species,
              column2: this.tissue,
            },
        ]
        };
   },
    props: {
      species: {
        type: String,
        required: true
      },
      tissue: {
        type: String,
        required: true
      }
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/seAnalysis/Sample.vue